import { IGeneralObjectType } from 'src/compass/site/util';

import ICasTableColumn from './ICasTableColumn';
import CasTable, { CasTableStyles } from './CasTable';
import getCasTableCellValue from './getCasTableCellValue';
import ICasRenderCellProps from './ICasRenderCellProps';
import { TRowSx } from './CasTableBody';

import defaultLabelFromField from '../../util/defaultLabelFromField';

const ROW_HEADER_1 = 'metricLabel';

interface ITransformedRow extends ICasTableColumn {
  [ROW_HEADER_1]: string;
  [key: string]: any;
}

interface Props {
  data: { result: IGeneralObjectType[] };
  columns: ICasTableColumn[];
  align?: ICasTableColumn['align'];
  colSx?: TRowSx;
}

export default function CasTableRowsAsColumns({ columns: parmColumns, data: parmData, align, colSx }: Props) {
  const columnKeyPropertyName = parmColumns[0].field ?? '';
  const columns = [
    {
      render: ({ row }: ICasRenderCellProps) => row[ROW_HEADER_1],
      sx: (row: any, column: any) => (row.sx ? row.sx(row, column) : {}),
      align,
    },
    ...parmData.result.map((dataRow) => ({
      field: dataRow[columnKeyPropertyName],
      label: dataRow[columnKeyPropertyName],
      align,
      sx: (row: any, column: any) => {
        const rowStyle = row.sx ? row.sx(row, column) : {};
        const colStyle = colSx?.(dataRow) || {};
        return { ...colStyle, ...rowStyle };
      },
      render: ({ row, column }: ICasRenderCellProps) =>
        row.render ? row.render({ row, column }) : getCasTableCellValue({ row, column }),
    })),
  ];

  const data: ITransformedRow[] = parmColumns.map((metricCol) => {
    const newRow: ITransformedRow = {
      ...metricCol,
      [ROW_HEADER_1]: metricCol.label ?? defaultLabelFromField(metricCol.field),
      sx: metricCol.field === columnKeyPropertyName ? CasTableStyles.headerStyles : metricCol.sx,
    } as ITransformedRow;

    parmData.result.forEach((dataRow) => {
      newRow[dataRow[columnKeyPropertyName]] = metricCol.field
        ? dataRow[metricCol.field]
        : undefined;
    });

    return newRow;
  });

  return <CasTable showColumnHeaders={false} columns={columns} data={{ result: data }} />;
}
